// import { useFormField } from '@calendly/form'
import { useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { MailSendEnvelopeIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { useEffect, useState, forwardRef } from 'react';
import { useBulkOfErrorMessages } from '../../steps/add_emails_step/errors';
import { useNewAdminModal } from '../use-new-admin-modal';
const containerCss = "c37xye9";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const styledButtonCss = "suz58b2";
const StyledButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(styledButtonCss, props.className)} />);
export const SubmitButton = ({
  disabled = false
}) => {
  const isAdminFlagEnabled = useNewAdminModal();
  const {
    values: {
      invitations
    }
  } = useFormContext();
  const [isDisabled, setIsDisabled] = useState(disabled);
  const {
    errors: {
      invitations: errors = []
    }
  } = useFormContext();
  const errorMessages = useBulkOfErrorMessages(errors);
  useEffect(() => {
    if (isAdminFlagEnabled) {
      setIsDisabled(invitations.length === 0 || errorMessages.length > 0);
    } else {
      setIsDisabled(disabled);
    }
  }, [isAdminFlagEnabled, invitations, errorMessages, disabled]);
  const onSubmit = () => {
    // TODO: add tracking

    // Segment.track('invite_flow.next.click', {
    //   event: 'invite_flow.next.click',
    //   payload: {
    //     has_MET: hasMET,
    //     current_step: currentStep,
    //     invitee_count: invitations.length
    //   }
    // })
  };
  const button = <StyledButton type="submit" onClick={onSubmit} disabled={isDisabled} id="invite-user-modal-send-button">
      <MailSendEnvelopeIcon />
      {isAdminFlagEnabled && invitations.length > 1 ? I18n.t('publisher.add_users_modal.plural_invites_submit') : I18n.t('publisher.add_users_modal.submit')}
    </StyledButton>;
  return isAdminFlagEnabled ? <Container>{button}</Container> : button;
};

require("./submit_button.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./submit_button.js");